export default __webpack_public_path__ + "static/media/newAssignPic.93e7ce51.jpeg";